import { Dialog, DialogProps } from '../components/widgets/dialog';
import React, { FunctionComponent, Suspense } from 'react';
import { Loader } from './docsDialog';

interface CustomDialogWrapperProps extends DialogProps {
    windowDecorator?: FunctionComponent<any> | undefined;
    loader?: React.ReactNode;
    children: React.ReactNode;
}

export const CustomDialogWrapper: React.FC<CustomDialogWrapperProps> = (props) => {
    const { children, ...dialogProps } = props;

    return (
        <Dialog {...dialogProps} windowDecorator={props?.windowDecorator}>
            <Suspense fallback={props.loader ?? Loader}>{children}</Suspense>
        </Dialog>
    );
};
